import React from 'react';

import { Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { components } from 'react-select';

import { ArrowDown1 } from 'assets/assetsV1/iconComponents';

import { Select } from 'uiToolkitV1/Select';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const ArrowRight = styled(ArrowDown1)`
  rotate: -90deg;
  margin-right: 8px;
  color: ${(props) => props.theme.colors.neutral.CCCCCC};
`;

const OptionComponent = ({ ...props }) => {
  const { children, isSelected, data, options } = props ?? {};

  const optionIndex = options.findIndex((opt) => opt.id === data.id);

  return (
    <components.Option {...props}>
      <Flex alignItems="center" pl={optionIndex * 6}>
        <ArrowRight />
        <TextBodyMedium color={isSelected ? 'button.blue.focus' : 'text.g1'} bold={isSelected}>
          {children}
        </TextBodyMedium>
      </Flex>
    </components.Option>
  );
};

export const DepartmentFunctionHierarchySelect = ({ options = [], selectedOption = {}, onChange = () => {} }) => (
  <Select
    name="functionSelect"
    placeholder=""
    withBackground
    value={selectedOption}
    options={options}
    handleChange={onChange}
    getOptionValue={(option) => option.id}
    getOptionLabel={(option) => option.name}
    formControlProps={{ height: '40px' }}
    isSearchable={false}
    components={{ Option: OptionComponent }}
  />
);
